import React, { useState } from "react";
import { useI18n } from "@/i18n";
import { ApiError, sendFeedback } from "@/lib/api";
import { haptic } from "@/lib/telegram";

const REASONS = ["late", "packaging", "wrong_item", "courier", "other"] as const;

/** "Как всё прошло?" after delivery. 1–3 stars ask what went wrong; staff see it immediately. */
export function ServiceRating({ orderId, onDone }: { orderId: string; onDone: (rating: number) => void }) {
  const { t } = useI18n();
  const [rating, setRating] = useState(0);
  const [reasons, setReasons] = useState<string[]>([]);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const low = rating > 0 && rating <= 3;

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await sendFeedback(orderId, { rating, reasons: low ? reasons : [], comment: comment.trim() || undefined });
      haptic("success");
      onDone(rating);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t("common.error"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rate">
      <div className="rate__title">{t("rating.title")}</div>
      <div className="rate__hint">{t("rating.hint")}</div>
      <div className="stars-input" role="radiogroup" aria-label={t("rating.title")} style={{ justifyContent: "center", margin: "12px 0" }}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} role="radio" aria-checked={rating === n} data-active={n <= rating} onClick={() => { haptic("selection"); setRating(n); }}>
            ★
          </button>
        ))}
      </div>
      {low && (
        <div className="segmented" style={{ flexWrap: "wrap", justifyContent: "center", marginBottom: 12 }}>
          {REASONS.map((r) => (
            <button key={r} className="chip" data-active={reasons.includes(r)} onClick={() => setReasons((p) => (p.includes(r) ? p.filter((x) => x !== r) : [...p, r]))}>
              {t(`rating.reasons.${r}`)}
            </button>
          ))}
        </div>
      )}
      {rating > 0 && (
        <>
          <div className="field" style={{ marginBottom: 12 }}>
            <textarea rows={2} maxLength={1000} value={comment} onChange={(e) => setComment(e.target.value)} placeholder={low ? t("rating.placeholderLow") : t("rating.placeholder")} />
          </div>
          {error && <div className="form-error-banner">{error}</div>}
          <button className="btn btn--primary" disabled={busy} onClick={submit}>
            {t("rating.send")}
          </button>
        </>
      )}
    </div>
  );
}
